import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Building, Site } from 'src/app/models';
import { faTimes, faSave } from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'app-building-dialog',
  templateUrl: './building-dialog.component.html',
  styles: [``],
})
export class BuildingDialogComponent implements OnInit {
  public form: FormGroup;
  public faTimes = faTimes;
  public faSave = faSave;
  constructor(
    public dialogRef: MatDialogRef<BuildingDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: { building: Building; title: string; buildings: Building[]; sites: Site[] },
  ) {}

  ngOnInit() {
    const formFields: { [key: string]: any } = {
      name: [this.data.building.name, Validators.required],
      siteId: [this.data.building.siteId, Validators.required],
    };
    if (this.data.building.id) {
      formFields.id = [this.data.building.id];
      formFields.createdBy = [this.data.building.createdBy];
      formFields.createdTime = [this.data.building.createdTime];
    }
    this.form = this.fb.group(formFields);
  }
  cancel() {
    this.dialogRef.close(null);
  }

  save() {
    this.dialogRef.close(this.form.value);
  }
}
